// extracted by mini-css-extract-plugin
export default {"searchBar":"styles_searchBar__WzDG1","dataTable":"styles_dataTable__9ii1z","dataTableFooter":"styles_dataTableFooter__2Bnpx"};